import { Brand, Vehicle } from '../types/catalog';
import { getQuickQuote } from './finance';

export interface CatalogFilters {
  brand: string;
  model: string;
  segment: string;
  body: string;
  maxPrice: number;
  maxMonthly: number;
  maxDown: number;
  term: number;
  sort: 'precio-asc' | 'precio-desc' | 'marca';
}

export const emptyFilters: CatalogFilters = {
  brand: '',
  model: '',
  segment: '',
  body: '',
  maxPrice: 0,
  maxMonthly: 0,
  maxDown: 0,
  term: 0,
  sort: 'marca',
};

export function filtersFromParams(p: URLSearchParams): CatalogFilters {
  const num = (k: string) => Number(p.get(k)) || 0;
  const sort = p.get('sort');
  return {
    brand: p.get('brand') ?? '',
    model: p.get('model') ?? '',
    segment: p.get('segment') ?? '',
    body: p.get('body') ?? '',
    maxPrice: num('maxPrice'),
    maxMonthly: num('maxMonthly'),
    maxDown: num('maxDown'),
    term: num('term'),
    sort: sort === 'precio-asc' || sort === 'precio-desc' ? sort : 'marca',
  };
}

export function filtersToParams(f: CatalogFilters): URLSearchParams {
  const p = new URLSearchParams();
  (Object.keys(f) as (keyof CatalogFilters)[]).forEach((k) => {
    const v = f[k];
    if (v && !(k === 'sort' && v === 'marca')) p.set(k, String(v));
  });
  return p;
}

export function filterVehicles(vehicles: Vehicle[], brands: Brand[], f: CatalogFilters): Vehicle[] {
  const list = vehicles.filter((v) => {
    if (!v.published) return false;
    if (f.brand && v.brandId !== f.brand) return false;
    if (f.model && v.model !== f.model) return false;
    if (f.segment && v.segment !== f.segment) return false;
    if (f.body && v.bodyType !== f.body) return false;
    if (f.maxPrice && v.price > f.maxPrice) return false;
    if (f.maxDown || f.maxMonthly || f.term) {
      const q = getQuickQuote(v, brands);
      if (!q) return false;
      if (f.maxDown && q.down > f.maxDown) return false;
      if (f.term && !q.ctx.offer.terms.includes(f.term)) return false;
      if (f.maxMonthly && (!q.sim || q.sim.firstInstallment > f.maxMonthly)) return false;
    }
    return true;
  });
  const brandName = (id: string) => brands.find((b) => b.id === id)?.name ?? id;
  return list.sort((a, b) => {
    if (f.sort === 'precio-asc') return a.price - b.price;
    if (f.sort === 'precio-desc') return b.price - a.price;
    return brandName(a.brandId).localeCompare(brandName(b.brandId)) || a.model.localeCompare(b.model);
  });
}

export function vehicleLabel(v: Vehicle, brands: Brand[]): string {
  const b = brands.find((x) => x.id === v.brandId)?.name ?? '';
  return `${b} ${v.model} ${v.version} (${v.year})`.trim();
}
